// @flow

import * as React from 'react';
import moment from 'moment';
import DateRange from 'common/domain/DateRange';
import { ISO_DAYS } from 'common/domain/DayOfWeek';
import { DatePicker } from './inner/DatePicker';
import { Range } from './inner/DatePickerRange';
import { Modifiers } from './inner/DatePickerDayModifier';

export interface DateRangePickerProps {
  dateRange: DateRange;
  maxDate: moment | void;
  minDate: moment | void;
  onChange: (value: DateRange) => void;
}

interface Props extends DateRangePickerProps {
  disabledDates: any;
  getRange: (day: Date) => Range;
  selectableISODays: number[];
}

interface State {
  selectedRange: Range;
  hoverRange: Range;
}

export default class SpecificDateRangePicker extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      selectedRange: {
        from: this.props.dateRange.from.toDate(),
        to: this.props.dateRange.to.toDate(),
      },
      hoverRange: {
        from: undefined,
        to: undefined,
      },
    };
  }

  onDayLeave = () => this.setState({ hoverRange: { from: undefined, to: undefined } });

  onDayEnter = (day: Date, modifiers: Modifiers) => {
    if (modifiers.disabled) {
      return;
    }

    this.setState({ hoverRange: this.props.getRange(day) });
  }

  onDayClick = (day: Date, modifiers: Modifiers) => {
    if (modifiers.disabled) {
      return;
    }

    const { onChange, selectableISODays } = this.props;
    const isoDayNumber = moment(day).isoWeekday();
    if (!selectableISODays.includes(isoDayNumber)) {
      return;
    }

    const { hoverRange } = this.state;
    this.setState({ selectedRange: hoverRange });
    onChange(new DateRange({ from: moment(hoverRange.from), to: moment(hoverRange.to) }));
  }

  renderDay = (day: Date, { start, end }: Modifiers) => {
    if (!start && !end) {
      return day.getDate();
    }

    return (
      <div className="DayPicker-Day--edge">
        {day.getDate()}
      </div>
    );
  }

  getDaysOfWeekWithoutInteraction = (): number[] => {
    const { selectableISODays } = this.props;
    const selectableJSDays = selectableISODays.map((day) => {
      if (day !== ISO_DAYS.SUNDAY) {
        return day;
      }

      return 0;
    });
    const allJSDays = [0, 1, 2, 3, 4, 5, 6];

    return allJSDays.filter(day => !selectableJSDays.includes(day));
  }

  render() {
    const { selectedRange, hoverRange } = this.state;

    const modifiers = {
      start: [selectedRange.from, hoverRange.from],
      inRange: [selectedRange, hoverRange],
      end: [selectedRange.to, hoverRange.to],
      interactionDisabled: { daysOfWeek: this.getDaysOfWeekWithoutInteraction() },
    };

    return (
      <DatePicker
        disabledDates={this.props.disabledDates}
        date={this.props.dateRange.from}
        minDate={this.props.minDate}
        maxDate={this.props.maxDate}
        modifiers={modifiers}
        onChange={this.props.onChange}
        onDayClick={this.onDayClick}
        onDayMouseEnter={this.onDayEnter}
        onDayMouseLeave={this.onDayLeave}
        renderDay={this.renderDay}
        selectedDays={[selectedRange.from, selectedRange]}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ui/datePicker/SpecificDateRangePicker.js